import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './EditOwnDataSupportDocument.css';
import { Input, Button, Form, Drawer, Select } from 'antd';

import {
    SupportingDocumentUpdateHandler,
    clearDocumentsSupportingData,
} from '../../../../../Redux/Actions/user/SupportingDocumentsUpdate';
import { workspaces_List_ActionHandler } from '../../../../../Redux/Actions/user/WorkspacesList';
import { workspaces_FolderList_ActionHandler, workspaces_Support_Documents_ActionHandler } from '../../../../../Redux/Actions/user/WorkspaceSupportingDocumentList';
import Loader from '../../../../../Components/Loader/Loader';
import { workspaces_OutputFormatsId_ActionHandler } from '../../../../../Redux/Actions/user/workspacesOutputFormatsId';
import { workspaces_SupportingDocumentsId_ActionHandler } from '../../../../../Redux/Actions/user/workspacesSupportingDocumentsId';
const { TextArea } = Input;
const { Option } = Select;
const EditOwnDataSupportDocument = ({
    isOwnDataEditReferData,
    handleEditClick,
    editSupportData,
    workspace_id,
    folder_id,
    workspaceFolderFlag,
}) => {
    const SideClose = '/assets/ModalClose.svg';
    let dispatch = useDispatch();
    const [workspaceId, setWorkspaceId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [workspaceFolderId, setworkspaceFolderId] = useState('');
    const [wid, setWid] = useState("");
    const formRef = React.createRef();
    const supportingdocumentsupdateddata = useSelector(
        (state) =>
            state?.WorkspaceSupportDocumentsUpdateData
                ?.workspace_support_documents_update_data
    );
    const workspaceData = useSelector(
        (state) => state?.workspaces_List_Data?.workspace_create_data?.data
    );
    const workspaceFolderListData = useSelector(
        (state) =>
            state?.workspaces_Supporting_Document_FolderList_Data
                ?.workspace_supporting_documentlist_data?.data
    );
    const onFinish = (values) => {
        setLoading(true)
        if (!workspace_id) {
            workspace_id = workspace_id;
            folder_id = folder_id;
        } else {
            workspace_id = values.workspace_id;
            folder_id = workspaceFolderId;
        }
        const submitObject = {
            id: editSupportData.id,
            workspace_id: parseInt(workspace_id, 10),
            folder_id: parseInt(folder_id, 10),
            name: values.name,
            context: values.context,
            type: 'text',
            data: values.data,
        };
        dispatch(SupportingDocumentUpdateHandler(submitObject));
    };

    useEffect(() => {
        if (supportingdocumentsupdateddata) {
            handleEditClick(false);
            dispatch(clearDocumentsSupportingData());
        }
    }, [supportingdocumentsupdateddata, dispatch]);
    useEffect(() => {
        setworkspaceFolderId(editSupportData.folder.id)
        dispatch(workspaces_List_ActionHandler('', ''));
        return () => {
            setLoading(false)
            dispatch(workspaces_FolderList_ActionHandler(workspace_id, '', ''));
            dispatch(workspaces_OutputFormatsId_ActionHandler(workspace_id, ''));
            dispatch(
                workspaces_SupportingDocumentsId_ActionHandler(workspace_id, '')
            );
        }
    }, []);
    const handleChangeWorkspace = (value) => {
        setworkspaceFolderId(null)
        formRef.current.resetFields(['folder_id']);
        setWorkspaceId(value);
    };
    useEffect(() => {
        if (workspaceId) {
            dispatch(
                workspaces_Support_Documents_ActionHandler(workspaceId, '', '')
            );
        }
    }, [workspaceId]);
    useEffect(() => {
        if (editSupportData) {
            dispatch(
                workspaces_Support_Documents_ActionHandler(
                    editSupportData.folder.workspace_id,
                    '',
                    ''
                )
            );
        }
    }, [editSupportData]);
    const handleSelect = (value) => {
        setworkspaceFolderId(value);
    };
    const handleChange = (value) => {
        setworkspaceFolderId(value);
    };
    return (
        <>
            <Drawer
                placement='right'
                closable={false}
                onClose={handleEditClick}
                open={isOwnDataEditReferData}
                key='right'
                width={'40%'}>
                <img
                    className='edit-own-data-side-close'
                    src={SideClose}
                    alt=''
                    onClick={handleEditClick}
                />
                {loading && <Loader />}
                <Form
                    name='uploadComputerForm'
                    initialValues={{
                        name: editSupportData.name,
                        context: editSupportData.context,
                        data: editSupportData.data,
                        workspace_id: editSupportData.folder.workspace_id,
                        folder_id: editSupportData.folder.id,
                    }}
                    ref={formRef}
                    onFinish={onFinish}>
                    <div className='edit-own-data-modal-div'>
                        <h3>Edit Supporting Document</h3>
                    </div>
                    <div className='supporting-document-1'>
                        <label>Supporting document name</label>
                        <Form.Item
                            name='name'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your name!',
                                },
                                {
                                    type: 'name',
                                    message: 'Please enter a valid name',
                                },
                            ]}>
                            <Input placeholder='Enter your name' />
                        </Form.Item>
                    </div>
                    <div className='edit-own-data-2'>
                        <label>Reference data</label>
                        <Form.Item
                            name='data'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select the data!',
                                },
                            ]}>
                            <TextArea rows={4} />
                        </Form.Item>
                        {workspaceFolderFlag ? null : (
                            <>
                                <div className='own-data-modal-div'>
                                    <h3>Select Destination Directory</h3>
                                </div>
                                <div className='own-data-input'>
                                    <div className='own-data-1'>
                                        <label>Select Workspace</label>
                                        <Form.Item
                                            name='workspace_id'
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        'Please select a workspace!',
                                                },
                                            ]}>
                                            <Select
                                                className='uploadcomputer-select'
                                                onChange={
                                                    handleChangeWorkspace
                                                }>
                                                {workspaceData &&
                                                    workspaceData.map(
                                                        (workspace) => (
                                                            <>
                                                                {!workspace.is_locked && (
                                                                    <Option
                                                                        key={
                                                                            workspace.id
                                                                        }
                                                                        value={
                                                                            workspace.id
                                                                        }>
                                                                        {
                                                                            workspace.name
                                                                        }
                                                                    </Option>
                                                                )}
                                                            </>
                                                        )
                                                    )}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                    <div className='own-data-2'>
                                        <label>Select Folder</label>
                                        <Form.Item
                                            name='folder_id'
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        'Please select a folder!',
                                                },
                                            ]}>
                                                <div>
                                            <Select
                                                className='uploadcomputer-select'
                                                name='folder_id'
                                                value={workspaceFolderId}
                                                onSelect={handleSelect}
                                                onChange={handleChange}>
                                                {workspaceFolderListData &&
                                                    workspaceFolderListData.map(
                                                        (folder) => (
                                                            <Option
                                                                key={folder.id}
                                                                value={
                                                                    folder.id
                                                                }>
                                                                {folder.name}
                                                            </Option>
                                                        )
                                                    )}
                                            </Select>
                                            </div>
                                        </Form.Item>
                                    </div>
                                </div>
                            </>
                        )}
                        <div className='edit-own-data-supporting-div'>
                            <Form.Item>
                                <Button
                                    type='primary'
                                    htmlType='submit'
                                    block
                                    className='edit-own-data-supporting-button'>
                                    Edit & Save
                                </Button>
                            </Form.Item>
                        </div>
                    </div>
                </Form>
            </Drawer>
        </>
    );
};
export default EditOwnDataSupportDocument;
